<template>
  <div>
    <!--기본정보-->
    <field-select-module
      title="기본정보(담당자 정보)"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
    />
    <!-- 종사자 정보 -->
    <div class="mt-10">
      <h5 class="mt-6 mb-4"><i class="dot"></i> 종사자 정보</h5>
      <div class="writeGridContainer">
<!--        <div v-if="!isPrint">-->
<!--          <div>종사자(ID) 선택</div>-->
<!--&lt;!&ndash;          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>&ndash;&gt;-->
<!--          <EmployeeSelector v-model="form.inputA_1" @select="onSelectEmployee" />-->
<!--        </div>-->
<!--        <div v-if="!isPrint"></div>-->
<!--        <div v-if="!isPrint"></div>-->
        <div>
          <div>설립</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <vs-select
            class="w-full"
            autocomplete
            v-model="form.inputA_10"
            placeholder="선택하세요."
          >
            <vs-select-item
              v-for="option in ['공립', '국립', '사립']"
              :key="option" :text="option" :value="option"
            />
          </vs-select>
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" disabled/>
        </div>
<!--        <div>-->
<!--          <div>학교(기관)명</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>-->
<!--          <ml-input v-else v-model="form.inputA_3" disabled />-->
<!--        </div>-->
        <div>
          <div>학교(기관)명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_11 }}</p>
          <field-selector v-else v-model="form.inputA_11" :field-name="form.inputA_3" :readonly="board.readonly" @select="onSelectSchool"/>
        </div>
        <div>
          <div>이름</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <vs-select v-else v-model="form.inputA_6"  autocomplete >
            <vs-select-item v-for="divide in subDivideList" :key="divide" :text="divide" :value="divide" />
          </vs-select>
        </div>
<!--        <div>-->
<!--          <div>부서</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>-->
<!--          <ml-input v-else v-model="form.inputA_4" disabled />-->
<!--        </div>-->
<!--        <div>-->
<!--          <div>구분</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>-->
<!--          <vs-select v-else v-model="form.inputA_5"  autocomplete disabled>-->
<!--            <vs-select-item v-for="divide in divideList" :key="divide" :text="divide" :value="divide" />-->
<!--          </vs-select>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div>직종</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>-->
<!--          <vs-select v-else autocomplete v-model="form.inputA_7" disabled>-->
<!--            <vs-select-item v-for="job in jobList" :key="job" :text="job" :value="job" />-->
<!--          </vs-select>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div>연락처</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>-->
<!--          <ml-input v-else v-model="form.inputA_9" disabled />-->
<!--        </div>-->
      </div>
    </div>

    <!-- 폐암 건강검진 결과 -->
    <div class="mt-10">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 폐암 건강검진 결과</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer gap-x-6 gap-y-4 mt-4">
        <div class="custom-row">
          <div>검진일</div>
          <div v-if="isPrint" class="print-input">
            {{ form.inputB_1 }}
          </div>
          <date-selector
            v-else
            class="w-full flex-1"
            v-model="form.inputB_1"
            :readonly="board.readonly"
          />
        </div>
        <div class="custom-row">
          <div>이상소견</div>
          <div v-if="isPrint" class="print-radio flex items-center gap-2">
            <i><feather-icon v-if="form.inputB_2 === '있음'" svgClasses="w-4 w-5" icon="CheckIcon" /></i>
            <p>있음</p>
            <i><feather-icon v-if="form.inputB_2 === '없음'" svgClasses="w-4 w-5" icon="CheckIcon" /></i>
            <p>없음</p>

            <span v-if="form.inputB_2_value" class="print-input" style="width: 50px;">{{form.inputB_2_value}}</span>
          </div>
          <div v-else class="flex" >
            <vs-radio style="width: 50px;" v-model="form.inputB_2" vs-value="있음">있음</vs-radio>
            <vs-radio style="width: 50px;" class="ml-4 " v-model="form.inputB_2" vs-value="없음">없음</vs-radio>
            <vs-select
              v-if="form.inputB_2 === '있음'"
              class="ml-4"
              style="width: 120px;"
              autocomplete
              v-model="form.inputB_2_value"
              placeholder="선택하세요."
            >
              <vs-select-item
                v-for="option in ['2', '2b', '3', '4A', '4B', '4X', '5']"
                :key="option"
                :text="option" :value="option" />
            </vs-select>
          </div>
        </div>
        <div class="custom-row"></div>
      </div>
      <div class="writeGridContainer gap-x-12 gap-y-4 mt-4">
        <div class="custom-row col-span-12" style="align-items: start;">
          <div>판정구분에 따른 권고사항</div>
          <div v-if="isPrint" class="print-textarea">
            {{ form.inputB_4 }}
          </div>
          <ml-textarea
            v-else
            :readonly="board.readonly"
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>
      </div>
      <div class="writeGridContainer gap-x-12 gap-y-4 mt-4">
        <div class="custom-row col-span-12" style="align-items: start;">
          <div>폐결절외 기타 권고사항</div>
          <div v-if="isPrint" class="print-textarea">
            {{ form.inputB_5 }}
          </div>
          <ml-textarea
            v-else
            :readonly="board.readonly"
            v-model="form.inputB_5"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TrainingDisasterClassSelector from "@/components/selector/TrainingDisasterClassSelector";
import KPagination from "@/components/kPagination/kPagination";
import { valueDisasters } from "@/util/DisasterDataUtil";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import HttpRequest from "@/util/HttpRequest";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector,
    EmployeeSelector,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TrainingDisasterClassSelector,
    KPagination,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    reportList() {
      if (this.$store.state.board.postListInfo.data) {
        return this.$store.state.board.postListInfo.data.map((item) => {
          return { id: item.id, ...this.getContent(item).body };
        });
      } else return [];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',
        inputA_10: '', // 설립: 공립, 국립, 사립
        inputA_11: '',

        inputB_1: '',
        inputB_2: '없음',
        inputB_2_value: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
      },

      divideList: [
        "급식종사자",
        "시설관리자",
        "통학차량 관련자",
        "미화원",
        "당직전담원",
      ],
      subDivideList: [
        "영양교사",
        "영양사",
        "조리사",
        "조리실무사"
      ],
      jobList: ["공무원", "공무직", " 임기제", "기간제", "기능직", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value.inputB_2 === '없음') {
          value.inputB_2_value = ''
        }
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.value) {
      const keys = Object.keys(this.form);
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key];
        }
      }

      this.initEmployeeList();
    }
  },
  methods: {
    async initEmployeeList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.$route.params.proj_id;

      const payload = {
        projectId,
        page,
        perPage,
      };

      this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload).then((result) => {
        console.log(result)
      })
    },

    onSelectEmployee(data) {
      HttpRequest.get(`/api/v1/field/${data.fields[0].id}`).then((response) => {
        this.form.inputA_2 = response.facility_category.cat3;
      });

      // 학교(기관)명
      this.form.inputA_3 = data.fields[0].field_name;
      // 부서
      this.form.inputA_4 = data.company.com_name;
      // 구분
      this.form.inputA_5 = data.job_category;
      // 직종
      this.form.inputA_7 = data.employment_type;
      // 이름
      this.form.inputA_8 = data.full_name;
      // 연락처
      this.form.inputA_9 = data.contact_number;
    },

    onSelectSchool(data) {
      // 구분 (학교 구분)
      this.form.inputA_2 = data.facility_category.cat3;
      // 학교(기관)명
      this.form.inputA_3 = data.field_name
    },
  },
};
</script>

<style scoped lang="scss">
.custom-row {
  align-items: center;
  display: flex;
  width: 100%;
  //grid-template-columns: 114px 1fr;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  //padding-right: 12px;
}

#popupReportList::v-deep > .vs-popup {
  width: 90vw !important;
}
</style>


<style lang="scss" scoped>
.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;

  & > i {
    width: 20px;
    height: 20px;
    border: 2px solid #cdcdcd;
    position: relative;
    margin-right: 6px;
  }
  & .feather-icon {
    transform: translateY(-4px);
  }
}

.print-radio {
  & > i {
    border-radius: 20px;
  }
}
</style>
